<script setup>
import {ref, reactive, watch, onMounted, inject} from "vue";
import useForm from "@/composables/useForm";
import useDebounce from "@/composables/useDebounce";
import SelectFilter from "@/views/trackers/tracker/SelectFilter.vue";
import constants from "@/constants/constants";
import projectsService from "@/services/projects.service";
import VueMultiselect from "vue-multiselect";

const filters = reactive({
    search: "",
    status: [],
    priority: [],
    user: [],
    startup: [],
});

const {resetForm, formFilled: filtersApplied} = useForm(filters);
const debounce = useDebounce();

const projectId = inject('projectId').value;
const tasksListUpdated = inject('tasksListUpdated');
const serverFilters = inject('serverFilters');
const showModal = ref(false);
const startupOptions = ref([]);
const userOptions = ref([]);

watch(() => filters, () => debounce(applyFiltersChange, 1000), { deep: true });

watch(tasksListUpdated, (value) => {
    if (value) {
        getOptionsForFilter();
    }
});


onMounted(() => {
    getOptionsForFilter();
});

const statusOptions = Object.keys(constants.tasksStatus).map(key => ({
    name: constants.tasksStatus[key],
    value: key,
}))

const priorityOptions = Object.keys(constants.tasksPriorities).map(key => ({
    name: constants.tasksPriorities[key],
    value: key,
}))

function applyFiltersChange() {
    serverFilters.value = {
        ...filters,
        status: filters.status.map(item => item.value),
        priority: filters.priority.map(item => item.value),
        startup: filters.startup.map(item => item.value),
        user: filters.user.map(item => item.value),
    };
}

async function getOptionsForFilter() {
    const {data} = await projectsService.getOptionsForFilter(projectId);
    startupOptions.value = data.startups;
    userOptions.value = data.users;
}

function open() {
    showModal.value = true;
}

defineExpose({
    open,
    filtersApplied,
    serverFilters,
});
</script>

<template>
    <b-modal v-model="showModal" hide-header hide-footer modal-class="modal-filter-task">
        <form class="form">
            <fieldset>
                <header class="modal-header" style="padding-right: 0; padding-left: 0;">
                    <h5 class="modal-title">Filter Tasks</h5>

                    <div class="pr-2" style="white-space: nowrap">
                        <a @click="resetForm" class="link">Clear All</a>
                    </div>

                    <button @click="showModal = false" type="button" aria-label="Close" class="close">×</button>
                </header>

                <div class="form__item">
                    <div class="form-search form-search--round">
                        <input v-model="filters.search" type="text" placeholder="Search list"/>
                    </div>
                </div>

                <div class="mb-4">
                    <SelectFilter
                        v-model="filters.status"
                        name="status"
                        :options="statusOptions"
                    />
                </div>

                <div class="mb-4">
                    <SelectFilter
                        v-model="filters.priority"
                        name="priority"
                        :options="priorityOptions"
                    />
                </div>

                <div class="mb-4">
                    <div class="form__item">
                        <label class="form__label">Assigned To</label>

                        <VueMultiselect
                            v-model="filters.user"
                            placeholder="Select User"
                            :options="userOptions"
                            multiple
                            select-label=""
                            deselect-label=""
                            label="name"
                            track-by="name"
                            class="multiselect-mid multiselect-modern pl-2"
                        />
                    </div>
                </div>

                <div class="mb-4">
                    <div class="form__item">
                        <label class="form__label">Company</label>

                        <VueMultiselect
                            v-model="filters.startup"
                            placeholder="Select Startup"
                            :options="startupOptions"
                            multiple
                            select-label=""
                            deselect-label=""
                            label="name"
                            track-by="name"
                            class="multiselect-mid multiselect-modern pl-2"
                        />
                    </div>
                </div>
            </fieldset>
        </form>
    </b-modal>
</template>

<style scoped>

</style>
